import {
  GET_TEAM_UNAVAILABILITY,
  GET_TEAM_UNAVAILABILITY_SUCCESS,
  GET_TEAM_UNAVAILABILITY_FAIL,
  ADD_TEAM_UNAVAILABILITY,
  ADD_TEAM_UNAVAILABILITY_SUCCESS,
  ADD_TEAM_UNAVAILABILITY_FAIL,
  UPDATE_TEAM_UNAVAILABILITY,
  UPDATE_TEAM_UNAVAILABILITY_SUCCESS,
  UPDATE_TEAM_UNAVAILABILITY_FAIL,
  DELETE_TEAM_UNAVAILABILITY,
  DELETE_TEAM_UNAVAILABILITY_SUCCESS,
  DELETE_TEAM_UNAVAILABILITY_FAIL,
  SET_TEAM_UNAVAILABILITY_FIELD_ERRORS,
} from './actionTypes'

// Get Team Unavailability
export const getTeamUnavailability = (id) => ({
  type: GET_TEAM_UNAVAILABILITY,
  payload: id
})

export const getTeamUnavailabilitySuccess = (unavailability) => ({
  type: GET_TEAM_UNAVAILABILITY_SUCCESS,
  payload: unavailability,
})

export const getTeamUnavailabilityFail = (error) => ({
  type: GET_TEAM_UNAVAILABILITY_FAIL,
  payload: error,
})

// Add Team Unavailability
export const addTeamUnavailability = (teamUnavailability) => ({
  type: ADD_TEAM_UNAVAILABILITY,
  payload: teamUnavailability,
})

export const addTeamUnavailabilitySuccess = (teamUnavailability) => ({
  type: ADD_TEAM_UNAVAILABILITY_SUCCESS,
  payload: teamUnavailability,
})

export const addTeamUnavailabilityFail = (error) => ({
  type: ADD_TEAM_UNAVAILABILITY_FAIL,
  payload: error,
})

// Update Team Unavailability
export const updateTeamUnavailability = (teamUnavailability) => ({
  type: UPDATE_TEAM_UNAVAILABILITY,
  payload: teamUnavailability,
})

export const updateTeamUnavailabilitySuccess = (teamUnavailability) => ({
  type: UPDATE_TEAM_UNAVAILABILITY_SUCCESS,
  payload: teamUnavailability,
})

export const updateTeamUnavailabilityFail = (error) => ({
  type: UPDATE_TEAM_UNAVAILABILITY_FAIL,
  payload: error,
})

// Delete Team Unavailability
export const deleteTeamUnavailability = (id, teamId) => ({
  type: DELETE_TEAM_UNAVAILABILITY,
  payload: { id, teamId },
})

export const deleteTeamUnavailabilitySuccess = (id) => ({
  type: DELETE_TEAM_UNAVAILABILITY_SUCCESS,
  payload: id,
})

export const deleteTeamUnavailabilityFail = (error) => ({
  type: DELETE_TEAM_UNAVAILABILITY_FAIL,
  payload: error,
})

// Set Field Errors
export const setTeamUnavailabilityFieldErrors = (errors) => ({
  type: SET_TEAM_UNAVAILABILITY_FIELD_ERRORS,
  payload: errors,
})
